import { RouteComponent } from '@app/route/route.component';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import {
  StateService,
  ZaverProduct,
  WaitThen,
} from '@app/service/state/state.service';
import { HeaderService } from '@app/service/header/header.service';
import { ValuePipe } from '@app/shared/pipe/value.pipe';
import { SelectorItem } from '@app/component/selector/selector.component';
import { CheckoutType, RedirectService } from '@app/service/redirect-service/redirect.service';
import { PaymentMethod } from '@app/model/payment-request/payment-request.dto';
import { Subscription } from 'rxjs';

@Component({
  selector: 'se-success-page',
  templateUrl: './se-success-page.component.html',
  styleUrls: ['../../page-shared.css', './se-success-page.component.scss'],
})
export class SeSuccessPageComponent extends RouteComponent implements OnInit {
  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private valuePipe: ValuePipe,
    private redirectService: RedirectService
  ) {
    super(router, route, stateService, headerService);
  }
  selectorItems: SelectorItem[] = null;
  modalActive: boolean = false;

  successUrl: string;
  loading: boolean = true;
  noResponseMessage: string;

  successTitle: string;
  successPageText: string;

  isInstantDebitPayment: boolean = false;
  isA2APayment: boolean = false;

  public readonly APP_STORE_LINK =
    'https://apps.apple.com/se/app/zaver-handla-på-dina-villkor/id1560858500';
  public readonly PLAY_STORE_LINK =
    'https://play.google.com/store/apps/details?id=io.zaver.app';

  ngOnInit(): void {
    if (this.state.zaverProduct !== ZaverProduct.PRECHECK) {
      this.selectorItems = [
        {
          tab: 'Ditt köp',
          title: 'Sammanfattning',
          descriptions: [{ text: this.state.paymentInformation.description }],
          lineItems: this.state.paymentInformation?.lineItems,
          totalValue: `Totalbelopp inkl. moms: ${this.valuePipe.transform(
            this.state.totalCheckoutValue
          )}`,
        },
      ];
    }
    if (this.state.zaverProduct !== ZaverProduct.TOKENIZED_ONBOARDING && this.state.paymentInformation?.paymentMethod === PaymentMethod.INSTANT_DEBIT) {
      this.isInstantDebitPayment = true;
    } else if (this.state.paymentInformation?.paymentMethod === PaymentMethod.ZAVER_A2A) {
      this.isA2APayment = true;
    }
    this.successTitle = this.getPageTitle();
    this.successPageText = this.getPageText();
    this.tryRedirectToSuccessUrl();
  }

  public openTab(url: string): void {
    window.open(url);
  }

  toggleModal(): void {
    this.modalActive = !this.modalActive;
  }

  isType(type: string): boolean {
    return this.state.currentPageInformation.pageSpecificParameters?.pageTemplate === type;
  }

  getPageTitle(): string {
    if (this.isInstantDebitPayment || this.isA2APayment) {
      return 'Tack för att du betalar med Zaver!';
    }
    return 'Klart!';
  }

  getPageText(): string {
    if (this.isInstantDebitPayment) {
      return 'Pengarna dras från det valda kontot inom 1-3 bankdagar.';
    } else if (this.isA2APayment) {
      return 'Beloppet kommer att dras från ditt valda bankkonto.'
    }

    switch (this.state.zaverProduct) {
      case ZaverProduct.PRECHECK:
        return `Du kan stänga detta fönster eller återvända till ${this.state.checkoutCustomizations.merchantName}.`;
      case ZaverProduct.TOKENIZED_PAYMENT:
        return 'Du kan stänga detta fönster.';
      default:
        return 'Betalmetoden är nu aktiverad och kan användas för framtida köp.';
    }
  }

  showAppLinks(): boolean {
    return this.state.zaverProduct !== ZaverProduct.PRECHECK;
  }

  onRouteToSuccessUrl(): void {
    window.location.href = this.successUrl;
  }

  async tryRedirectToSuccessUrl(): Promise<void> {
    let redirectSubscription: Subscription;

    // If the readyToLeave endpoint takes to long time,
    // just show the success page after 5 seconds with redirect button.
    // this should be handle by the backend but quick fix for now.
    const timeoutId = setTimeout(() => {
      this.loading = false;
      this.successUrl = this.state.merchantUrls?.onSuccessUrl;

      if (redirectSubscription) {
        redirectSubscription.unsubscribe();
      }
    }, 5000);

    redirectSubscription = (
      await this.redirectService.tryRedirect(CheckoutType.BACKEND_DRIVEN_CHECKOUT, true)
    ).subscribe((stayOrLeave) => {
      switch (stayOrLeave.then) {
        case WaitThen.WAIT:
          break;
        case WaitThen.STAY:
          clearTimeout(timeoutId);
          this.loading = false;
          this.successUrl = this.state.merchantUrls?.onSuccessUrl;
          break;
        case WaitThen.LEAVE:
          clearTimeout(timeoutId);
          this.successUrl = this.state.merchantUrls?.onSuccessUrl;
          // Don't stop the loading there as the redirection is handled 
          break;
      }
    });
  }
}
